import gql from 'graphql-tag';

const getOrgCreditsQuery = gql`
  query GetOrgCredits($organisationId: String!) {
    getOrganisation(organisationId: $organisationId) {
      creditBalance {
        balance
        rolloverBalance
      }
      package {
        creditType
        videoQuantity
      }
    }
  }
`;

const getOrgCredits = (organisationId) => ({
  query: getOrgCreditsQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: () => ({ organisationId })
});

export default getOrgCredits;